<template>
  <b-modal
    ref="modal-nps"
    centered
    :hide-footer="true"
    :hide-header="true"
    size="lg"
  >
    <div class="d-flex flex-column align-items-center w-100">
      <div class="align-self-end">
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-secondary"
          class="btn-icon"
          size="md"
          @click="$refs['modal-nps'].hide();"
        >
          <feather-icon icon="XIcon" />
        </b-button>
      </div>
    <div class="d-flex justify-content-center align-items-center w-100 px-4">
        <div
            v-for="(label, n) in stepLabels"
            :key="n"
            class="d-flex flex-column align-items-center position-relative"
            style="min-width: 80px;"
        >
            <div
            class="step-circle"
            :class="{ active: step === n+1, done: step > n+1 }"
            >
            {{ n+1 }}
            </div>
            <small :class="step === n+1 ? 'text-danger fw-bold mt-1' : 'text-muted mt-1'">
            {{ label }}
            </small>
            <div v-if="n < stepLabels.length - 1" class="step-line"></div>
        </div>
    </div>
    <div v-if="step === 1" class="text-center w-100">
      <hr class="mb-2" />
      <h5 class="mb-2">Seberapa lengkap produk yang Anda butuhkan?</h5>
      <b-form-rating
        no-border
        stars="5"
        size="lg"
        style="font-size:2.5rem;"
        class="mb-2"
        v-model="form.konten"
      />
      <div class="d-flex justify-content-between w-100">
        <div style="min-width:120px;"></div>
        <b-button variant="danger" style="min-width:120px;" @click="nextStep">Next</b-button>
      </div>
    </div>
    <div v-if="step === 2" class="text-center w-100">
      <hr class="mb-2" />
      <h5 class="mb-2">Seberapa mudah Anda mengakses dan menemukan informasi yang dibutuhkan?</h5>
      <b-form-rating
        no-border
        stars="5"
        size="lg"
        style="font-size:2.5rem;"
        class="mb-3"
        v-model="form.akses"
      />
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" style="min-width:120px;" @click="prevStep">Previous</b-button>
        <b-button variant="danger" style="min-width:120px;" @click="nextStep">Next</b-button>
      </div>
    </div>
    <div v-if="step === 3" class="text-center w-100">
      <hr class="mb-2" />
      <h5 class="mb-2">Seberapa bermanfaat Product Catalog dalam menunjang pekerjaan Anda?</h5>
      <b-form-rating
        no-border
        stars="5"
        size="lg"
        style="font-size:2.5rem;"
        class="mb-3"
        v-model="form.manfaat"
      />
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" style="min-width:120px;" @click="prevStep">Previous</b-button>
        <b-button variant="danger" style="min-width:120px;" @click="nextStep">Next</b-button>
      </div>
    </div>
    <div v-if="step === 4" class="text-center w-100">
      <hr class="mb-2" />
      <h5 class="mb-2">Kritik & Saran</h5>
      <b-form-textarea
        v-model="form.saran"
        placeholder="Bagikan masukan dan pengalaman Anda"
        class="mb-2"
        :state="isValid ? true : false"
      />
      <span class="text-muted float-right">
        ( Minimal 3 kata & maksimal 160 karakter ) {{ form.saran.length }}/160
      </span>
      <div class="d-flex justify-content-between w-100 mt-4">
        <b-button variant="secondary" style="min-width:120px;" @click="prevStep">Previous</b-button>
        <b-button variant="danger" style="min-width:120px;" @click="rateApp" :disabled="isSubmitting">Submit</b-button>
      </div>
    </div>
    </div>
  </b-modal>
</template>
<script>
import {
  VBModal,
  BContainer,
  BRow,
  BCol,
  BButton,
  BCard,
  BCardText,
  BModal,
  BFormRating,
  BFormTextarea,
  BFormText,
  BFormInvalidFeedback
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BButton,
    BCard,
    BCardText,
    BModal,
    BFormRating,
    BFormTextarea,
    BFormText,
    BFormInvalidFeedback
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      step: 1,
      stepLabels: ["Konten", "Akses", "Manfaat", "Kritik & Saran"],
      isSubmitting: false,
      form: {
        konten: null,
        akses: null,
        manfaat: null,
        saran: ''
      }
    }
  },
  mounted() {
    this.$store.commit('app/setModalNPSElement', this.$refs['modal-nps'])
  },
  computed: {
    isValid() {
      const wordCount = this.form.saran.trim().split(/\s+/).length
      return wordCount >= 3 && this.form.saran.length <= 160
    },
  },
  methods: {
    nextStep() {
      if (this.step === 1 && !this.form.konten) {
        this.$notif("Sorry", "Please provide a rating before continuing.", "danger")
        return
      }
      if (this.step === 2 && !this.form.akses) {
        this.$notif("Sorry", "Please provide a rating before continuing.", "danger")
        return
      }
      if (this.step === 3 && !this.form.manfaat) {
        this.$notif("Sorry", "Please provide a rating before continuing.", "danger")
        return
      }
      if (this.step < 4) this.step++
    },
    prevStep() {
      if (this.step > 1) this.step--
    },
    async rateApp() {
      if (this.isSubmitting) return

      if (!this.form.konten || !this.form.akses || !this.form.manfaat) {
        this.$notif("Sorry", "Please complete all ratings first.", "danger")
        return
      }
      if (!this.isValid) {
        this.$notif(
          "Sorry",
          "Your comment must contain at least 3 words and a maximum of 160 characters.",
          "danger"
        )
        return
      }

      this.isSubmitting = true

      const user = this.$store.getters['oauth/getActiveUser']
      const payload = {
        kode_user: String(user?.id || ""),  
        name: user?.name || "",
        position: user?.position || "",
        rating_content: this.form.konten || 0,
        rating_access: this.form.akses || 0,
        rating_benefit: this.form.manfaat || 0,
        rating_comment: this.form.saran || "", 
        origin: "browser"
      }
      try {
        const token = generateToken(payload)
        await this.$http.post(
          `${process.env.VUE_APP_API_HELPER_URL}/ratingAndReview`,
          payload,
          {
            headers: {
              "Client-Device": "browser",
              "Authorization": token,
              "Content-Type": "application/json"
            }
          }
        )
        this.$notif("Success", "Thank you for your feedback!", "success")
        this.$refs['modal-nps'].hide()
        this.$store.commit('app/setStatusNotifNPS', false)
      } catch (err) {
        console.error(err)
        this.$notif("Error", "Failed to submit rating. Please try again.", "danger")
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>
<style>
	.step-circle {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: #e9ecef;
		color: #6c757d;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1;
	}
	.step-circle.active {
		background: #dc3545;
		color: #fff;
	}
	.step-circle.done {
		background: #28a745;
		color: #fff;
	}
	.step-line {
		position: absolute;
		top: 18px;
		left: 50%;
		width: 100%;
		height: 2px;
		background: #dee2e6;
		z-index: 0;
	}
  .b-rating .b-icon.bi-star,
  .b-rating .b-icon.bi-star-fill,
  .b-rating .b-icon.bi-star-half {
    color: #ff9f43 !important;     
  }
  .b-rating .b-rating-star:hover .b-icon.bi-star,
  .b-rating .b-rating-star:hover .b-icon.bi-star-fill,
  .b-rating .b-rating-star:hover .b-icon.bi-star-half {
    color: #ff9f43 !important;     
  }
</style>